import React, { useState } from "react";
import Slider from "react-slick";
import YouTube from "react-youtube";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  NextArrow,
  PrevArrow,
  PlayIcon,
  NextArrowGrey,
  PrevArrowGrey,
  Video1Thumbnail,
  Video2Thumbnail,
  Video3Thumbnail,
} from "../assets";

const VideoSlider = () => {
  const [playingVideoId, setPlayingVideoId] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const videoData = [
    {
      title: "How To Launch A SaaS From Scratch",
      videoId: "RWYm-F1jaYw",
      thumbnail: Video1Thumbnail,
    },
    {
      title: "The SECRET To Succeeding In Your FIRST SaaS",
      videoId: "D89Q1RZ9JBA",
      thumbnail: Video2Thumbnail,
    },
    {
      title: "How to make £500 a day with AI (NO CODING)",
      videoId: "5_PX7RyVf3g",
      thumbnail: Video3Thumbnail,
    },
    {
      title: "How to Get Your First 100 Users",
      videoId: "YQ5Bf-U-iLE",
    },
    {
      title: "What Is SaaS?",
      videoId: "m1geJovQnfI",
    },
    {
      title: "4 UNTAPPED SaaS Ideas For 2025",
      videoId: "YZ71yN0xiE4",
    },
    {
      title: "Make $10K A Month Building Apps (NO CODING)",
      videoId: "e9GslWTOgYc",
    },
  ];

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: (
      <SampleNextArrow
        currentSlide={currentSlide}
        slidesToShow={3}
        slideCount={videoData.length}
      />
    ),
    prevArrow: <SamplePrevArrow currentSlide={currentSlide} slidesToShow={3} />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          nextArrow: (
            <SampleNextArrow
              currentSlide={currentSlide}
              slidesToShow={2}
              slideCount={videoData.length}
            />
          ),
          prevArrow: (
            <SamplePrevArrow currentSlide={currentSlide} slidesToShow={2} />
          ),
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          nextArrow: (
            <SampleNextArrow
              currentSlide={currentSlide}
              slidesToShow={1}
              slideCount={videoData.length}
            />
          ),
          prevArrow: (
            <SamplePrevArrow currentSlide={currentSlide} slidesToShow={1} />
          ),
        },
      },
    ],
    beforeChange: (oldIndex, newIndex) => {
      setCurrentSlide(newIndex);
    },
    // afterChange: () => {
    //   const sliderElement = document.querySelector(".slick-slider");
    //   if (sliderElement) {
    //     setSlideCount(sliderElement.querySelectorAll(".slick-slide").length);
    //   }
    // },
  };

  return (
    <div className="w-full mx-auto 2xl:max-w-[1240px] xl:max-w-[1024px] lg:max-w-[768px] md:max-w-[640px] max-w-full md:px-0 px-4">
      <Slider {...settings}>
        {videoData.map((video, index) => (
          <VideoCard
            key={index}
            video={video}
            playingVideoId={playingVideoId}
            setPlayingVideoId={setPlayingVideoId}
          />
        ))}
      </Slider>
    </div>
  );
};

const VideoCard = ({ video, playingVideoId, setPlayingVideoId }) => {
  const isPlaying = playingVideoId === video.videoId;

  const togglePlayPause = () => {
    if (isPlaying) {
      setPlayingVideoId(null);
    } else {
      setPlayingVideoId(video.videoId);
    }
  };

  const youtubeOptions = {
    height: "320",
    width: "100%",
    playerVars: {
      autoplay: isPlaying ? 1 : 0,
      controls: 1,
      rel: 0,
      modestbranding: 1,
    },
  };

  return (
    <div className="text-center p-[10px]">
      <div
        className="relative rounded-[10px] overflow-hidden cursor-pointer max-h-[320px] h-[320px]"
        onClick={togglePlayPause}
      >
        {!isPlaying ? (
          <>
            <img
              className="w-full h-full object-cover rounded-[10px]"
              src={video.thumbnail ? video.thumbnail : `https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg`}
              alt={video.title}
            />
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-full flex justify-center items-center">
              <img src={PlayIcon} alt="Play" width={48} height={48} />
            </div>
          </>
        ) : (
          <YouTube videoId={video.videoId} opts={youtubeOptions} />
        )}
        <h3 className="text-white mt-0 absolute bottom-0 backdrop-blur-3xl h-[56px] text-base leading-6 font-bold flex items-center justify-center w-full">
          {video.title}
        </h3>
      </div>
    </div>
  );
};

const SampleNextArrow = (props) => {
  const { className, onClick, currentSlide, slidesToShow, slideCount } = props;
  const isDisabled = currentSlide >= slideCount - slidesToShow;
  return (
    <div
      className={`${className} custom-next md:!-right-[40px] !-right-[10px] !flex items-center justify-center !w-10 !h-10`}
      onClick={isDisabled ? null : onClick}
      style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
    >
      <img
        src={isDisabled ? NextArrowGrey : NextArrow}
        alt="NextArrow"
        className="z-50"
      />
    </div>
  );
};

const SamplePrevArrow = (props) => {
  const { className, onClick, currentSlide } = props;
  const isDisabled = currentSlide === 0;
  return (
    <div
      className={`${className} custom-prev custom-prev md:!-left-[40px] !-left-[10px] !flex items-center justify-center !w-10 !h-10`}
      onClick={isDisabled ? null : onClick}
      style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
    >
      <img
        src={isDisabled ? PrevArrowGrey : PrevArrow}
        alt="PrevArrow"
        className="z-50"
      />
    </div>
  );
};

export default VideoSlider;
